module.exports = __webpack_public_path__ + "img/130.94133c33.jpg";